module.exports = __webpack_public_path__ + "img/img04.675903dd.svg";